module.exports = __webpack_public_path__ + "static/media/uparts.26c2b1ba.png";